import { render, staticRenderFns } from "./PdfDownloadButtonV2.vue?vue&type=template&id=0618fc08&scoped=true"
import script from "./PdfDownloadButtonV2.vue?vue&type=script&lang=js"
export * from "./PdfDownloadButtonV2.vue?vue&type=script&lang=js"
import style0 from "./PdfDownloadButtonV2.vue?vue&type=style&index=0&id=0618fc08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0618fc08",
  null
  
)

export default component.exports